import React from "react";
import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";
 
const SignUpPage = () => {
  return (
    <>
      <div className="flex flex-col h-screen w-full items-center">
        <img src={logo} alt="logo" className="w-[50%] logo" />
        <div className="flex flex-col w-[50%] signup">
          <div className="text-[20px] text-[#2F80ED]">
            Get Started with ClearResult
          </div>
          <div className="text-[14px] mb-4">Please register to continue</div>
          <div className="text-[14px] text-[#828282]">Store/Company Name</div>
          <input
            type="text"
            placeholder="Enter the store/company name"
            className="border border-[#2F80ED] rounded-lg px-3 py-2 text-[16px] mb-4"
          />
          <div className="text-[14px] text-[#828282]">Contact Name</div>
          <input
            type="text"
            placeholder="Enter the name" 
            className="border border-[#2F80ED] rounded-lg px-3 py-2 text-[16px] mb-4"
          />
          <div className="text-[14px] text-[#828282]">Mobile Number</div>
          <input
            type="number" 
            placeholder="Enter the mobile number"
            className="border border-[#2F80ED] rounded-lg px-3 py-2 text-[16px] mb-4"
          />
          <div className="text-[14px] text-[#828282]">Email ID/Username</div>
          <input
            type="text"
            placeholder="Enter the email ID/username"
            className="border border-[#2F80ED] rounded-lg px-3 py-2 text-[16px] mb-4"
          />
          <div className="text-[14px] text-[#828282]">Password</div>
          <input
            type="password"
            placeholder="*********************"
            className="border border-[#2F80ED] rounded-lg px-3 py-2 text-[16px] mb-2"
          />
          {/* <div className="text-[14px] text-[#828282]">Upload your logo</div>

          <div className="border border-[#2F80ED] rounded-lg  text-[16px] py-[2rem] flex justify-center items-center mb-3">
            <input className="cursor-pointer" id="file_input" type="file" />
          </div> */}
          <div className="flex flex-col mt-4 ">
            <button className="border-none bg-[#2F80ED] py-[10px] text-white rounded-lg">
              <Link to="/subscriptions">Signup</Link>
            </button>

            <button className="py-[10px] text-[#2F80ED] underline">
              <Link to="/">LogIn</Link>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUpPage;
